/* tslint:disable */
/* eslint-disable */
export enum TransactionStatus {
  Failed = 'Failed',
  Success = 'Success',
  Rejected = 'Rejected',
  Funded = 'Funded'
}
